import clsx from 'clsx'
import {SidebarMenuMain} from './SidebarMenuMain'
import {useSidebar} from '../Sidebar'

const SidebarMenu = () => {
  const {collapsed} = useSidebar()

  return (
    <div className='app-sidebar-menu flex-1 overflow-y-auto'>
      <div
        className={clsx(collapsed ? 'px-1' : 'px-3')}
        style={{background: '#131313'}}
        id='kt_app_sidebar_menu'
      >
        <SidebarMenuMain />
      </div>
    </div>
  )
}

export {SidebarMenu}
